import { useContext, useEffect, type FC } from "react";

import { LayoutActionsContext, type ILayoutSubMenu } from "src/contexts/layouts/LayoutContext";

/**
 * Defines the inputs accepted by this layout component.
 */
interface ISetPageSubMenusProps {
    subMenu: ILayoutSubMenu;
}

/**
 * Registers one submenu after render and removes its code during effect cleanup.
 *
 * Postconditions: The layout reducer replaces the first existing code match or appends the submenu.
 * Cleanup removes matching codes rather than restoring an earlier submenu with the same code.
 */
const AddPageSubMenu: FC<ISetPageSubMenusProps> = ({ subMenu }) => {
    const layoutContext = useContext(LayoutActionsContext);

    useEffect(
        () => {
            layoutContext.addSubMenu(subMenu);

            return () => {
                layoutContext.removeSubMenu(subMenu);
            };
        },
        [subMenu, layoutContext]
    );

    return null;
};

export default AddPageSubMenu;
